import React from 'react'
import {withStyles} from 'material-ui'
import classNames from 'classnames'


const styles = theme => ({
    root: {
        backgroundColor: theme.palette.hero,
        minHeight: theme.layout.heroTotalHeight - theme.layout.cardFloatUp,
        padding: "0 20px",
    },
    content: {
        '& > h1': {
            ...theme.typography.headline,
            color: theme.palette.contrast
        },
        '& > p': {
            ...theme.typography.body1,
            color: theme.palette.contrast
        },
        '& > ul > li': {
            ...theme.typography.body1,
            color: theme.palette.contrast
        },
        '& > address': {
            ...theme.typography.body1,
            color: theme.palette.contrast
        },
        '& > p > a': {
            color: theme.palette.contrast,
        },
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        paddingTop: '1em',
        color: theme.palette.contrast,
    },
})

export const Hero = withStyles(styles)(
    ({classes, className='', children, ...props}) => (
        <div className={classNames(classes.root, className)} {...props}>
            {children}
        </div>
    )
)

export const HeroContent = withStyles(styles)(
    ({classes, className='', children, ...props}) => (
        <div className={classNames(classes.content, className)} {...props}>
            {children}
        </div>
    )
)

export default Hero


// WEBPACK FOOTER //
// ./src/components/Hero.jsx